export default [
     {
          path: '/ldap-config',
          name: 'LdapConfig',
          component: () => import("@/views/Page/LdapConfig/LdapConfig.vue"),
          meta: {
               title: 'LDAP Config',
               requiresAuth: true,
          },
     },
     {
          path: '/ldap-departments',
          name: 'LdapDepartments',
          component: () => import("@/views/Page/LdapConfig/LdapDepartments.vue"),
          meta: {
               title: 'LDAP Departments',
               requiresAuth: true,
          },
     }
];
